/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import { SidebarGlobal } from "../_Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import { Modal } from "react-bootstrap";
import UploadPad from "../UploadPad";

class Storage extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            queue: [],
            list: [],
            totalCount: 0
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<div className="btn-group">
            <button type="button" className="btn btn-primary" onClick={() => this.setState({ showUpload: true })}><Icon icon="faUpload" /> <L>Upload</L></button>
            <button type="button" className="btn btn-secondary"><Icon icon="faFolder" /> <L>New Folder</L></button>
        </div>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {

    }

    render() {
        return <div className="container-fluid">
            <Modal show={this.state.showUpload} onHide={() => this.setState({ showUpload: false })}>
                <Modal.Header><L>Upload</L></Modal.Header>
                <Modal.Body>
                    <UploadPad item={this.state.queue} path={this.props.params.path} onUploadEnd={() => this.load()} />
                </Modal.Body>
            </Modal>
            <h1><L>Storage</L></h1>
            <DataTable columns={[
                { linkTitle: 'View File', icon: 'File', link: '/storage/:mid' },
                { name: 'name', title: 'File Name', link: '/storage/:mid' },
                { name: 'createdDate', title: 'Created' }
            ]} data={this.state.list} totalCount={this.state.totalCount} loading={!this.state.loaded} />
        </div>;
    }
}

export default withParamsAndNavigate(Storage);